import moment from 'moment';

export function selectWeiiYearWindow<T>(periods: Array<[string, T]>, selectedEnd?: string,
                                        maximumYears = 4): Array<[string, T]> {
    const focusYear = selectedEnd
        ? moment(selectedEnd).subtract(1, 'millisecond').year()
        : moment().year();
    const sorted = [...periods].sort(([left], [right]) => moment(left).year() - moment(right).year());
    const throughFocus = sorted.filter(([start]) => moment(start).year() <= focusYear);
    const selected = throughFocus.slice(-maximumYears);
    if (selected.length === maximumYears) return selected;

    const afterFocus = sorted.filter(([start]) => moment(start).year() > focusYear);
    return [...selected, ...afterFocus.slice(0, maximumYears - selected.length)];
}

export function weiiProvisionalThrough(year: number, now: moment.Moment = moment()): string | null {
    return year === now.year()
        ? now.clone().startOf('day').subtract(1, 'day').format('YYYY-MM-DD')
        : null;
}
